<template>
  <div class="SalesReportEdit">
    <div class="title">
      <h2
        v-if="created"
        class="light">
        New report entry
      </h2>
      <h2
        v-if="!created"
        class="light">
        Edit report entry
      </h2>
    </div>

    <div v-if="salesReportItem">
      <SalesReportItem
        @sales-report-item-deleted="$router.go(-1)"
        @saved="$router.go(-1)"
        :read-only="false"
        class="panel"
        :item="salesReportItem" />
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import SalesReportItem from "@/components/SalesReportItem";

export default {
  components: { SalesReportItem },
  props: {
    id: {
      type: Number,
      required: true,
    },
    created: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      salesReportItem: null,
    };
  },

  mounted() {
    this.$apollo
      .query({
        query: gql`
          query SalesReportItemQuery($id: Int!) {
            salesReportItem(id: $id) {
              amount
              customerType
              id
              location {
                id
                name
              }
              membership {
                id
                location {
                  id
                  name
                }
                customer {
                  id
                  firstName
                  lastName
                  gender
                  birthdate
                }
              }
            }
          }
        `,
        variables: { id: parseInt(this.id) },
      })
      .then((result) => {
        this.salesReportItem = result.data.salesReportItem;
      });
  },
};
</script>
